


























import type { PropType } from '@nuxtjs/composition-api';
// eslint-disable-next-line no-duplicate-imports
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';

import { useDeclination } from '~/diptyqueTheme/composable/useDeclination';
import type { MediaPreloadableSection } from '~/diptyqueTheme/types/components';
import type { EcomPushModel } from '~/integrations/contentful/src/types';

export default defineComponent({
  name: 'EcomPush',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    SfLink
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<EcomPushModel & MediaPreloadableSection>
    }
  },
  setup(props) {
    const declinationData = computed(() => props.sectionData);
    const { getBannerData } = useDeclination(props.sectionData);
    const bannerSrc = computed(() => getBannerData.value.src);
    const bannerLink = computed(() => getBannerData.value?.link || '');

    return {
      bannerLink,
      declinationData,
      getBannerData,
      bannerSrc
    };
  }
});
